import React, {} from "react";
import {
  Textarea,
} from "@chakra-ui/react";
import { 
  MdClose as IcoClose, 
} from 'react-icons/md';
import "./filesList.css";
// Utils
import { formatBytes } from '../../../utils/formatters';

const FilesList = ({
  files,
  setFiles,
  onDeleteFile,
  onUpdateFile,
  showTextFile = false,
}) => {
  const handleRemoveFile = (file) => {
    // console.log(`Removing ${file.name}..`);
    let finalFiles = [];
    for (var i = 0; i < files.length; i++) { 
      const currentFile = files[i];
      if (currentFile.name == file.name) continue;
      finalFiles.push(currentFile);
    }    
    setFiles(finalFiles);
    onDeleteFile(file);
  };

  const handleChangeDescription = (file, description) => {
    let finalFiles = [];
    let updated_file = null;
    for (var i = 0; i < files.length; i++) { 
      const currentFile = files[i];
      if (currentFile.name == file.name) {
        currentFile.description = description;
        updated_file = currentFile;
      }
      finalFiles.push(currentFile);
    }    
    setFiles(finalFiles);
    onUpdateFile(updated_file);
  };  

  const renderFile = (file, i) => {    
    const typePieces = file.type.split("/");
    let type = typePieces.length > 1 ? typePieces[1] : typePieces[0];
    type = (type || '').length > 10
      ? `${type.substring(0, 10).toUpperCase()}...`
      : (type || '').toUpperCase();
    return (
      <div className="upload-fileslist-file-main-container">
        <div className="upload-fileslist-file-wrapper">
          <div className="upload-fileslist-file-type">
            {type}
          </div>
          <div className="upload-fileslist-file-name-wrapper">
            <div className="upload-fileslist-file-name">
              {file.name}
            </div>
            <div className="upload-fileslist-file-size">
              {formatBytes(file.size)}
            </div>
          </div>            
          <div className="upload-fileslist-file-remove" 
            onClick={() => {
              handleRemoveFile(file)
            }}
          >
            <IcoClose size={18} />
          </div>        
        </div>
        {showTextFile && (
          <div className="upload-fileslist-file-textbox-description">
            <Textarea
              className="maintenance-form-field"
              placeholder="Texte del fitxer"
              onChange={(evt) => {
                handleChangeDescription(file, evt.target.value);
              }}
              value={!!file.description ? file.description : ""}
            /> 
          </div>
        )}
      </div>     
    );
  };

  return (
    <div className="upload-fileslist-wrapper">
      {files.map((file, i) => {
        return renderFile(file, i);
      })}    
    </div>    
  );
};

export default FilesList;
